import { Component } from '@angular/core';

@Component({
    selector: 'ctfo-dialog-content',
    templateUrl: './dialog-content.component.html',
    styleUrls: ['./dialog-content.component.scss'],
    standalone: false
})
export class DialogContentComponent {}
